import AppLink from './src/main'

AppLink.install = function(Vue) {
  Vue.component(AppLink.name, AppLink)
}

export default AppLink
